/* ============
 * All AccountingProviders
 * ============
 *
 * All accounting providers.
 */

import Vue from 'vue';
import store from './../../store';
import accountingProviderTransformer from './../../transformers/accountingProvider';

const success = ({ data }, resolve) => {
  const accountingProviders = accountingProviderTransformer.fetchCollection(data.data);

  store.dispatch('fetchAllAccountingProviders', accountingProviders);
  resolve(accountingProviders);
};

const failed = (error, reject) => reject(error);

// Display message template types.
export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('accounting_providers')
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/accountingProvider/all.js